export const enum MIXPANEL_TYPE {
  ADD_PLATFORM = 'AccountCreationStart',
}

export enum GA4_ACTIONS {
  ACCOUNT_START_TO_CREATE = 'AccountStartToCreate',
  ACCOUNT_CREATING_BUTTON_CLICK = 'AccountCreatingButtonClick',

  ACCOUNT_FACEBOOK_WORKFLOW_TYPE_SELECTED = 'AccountFacebookWorkflowTypeSelected',
  ACCOUNT_FACEBOOK_HOW_TO_CREATE_BM = 'AccountFacebookHowToCreateBM',
  ACCOUNT_FACEBOOK_HOW_TO_FIND_BM = 'AccountFacebookHowToFindBM',
  ACCOUNT_FACEBOOK_CHOSE_INDUSTRY = 'AccountFacebookChoseIndustry',
  ACCOUNT_FACEBOOK_TRY_TO_SEND_FORM = 'AccountFacebookTryToSendForm',
  ACCOUNT_FACEBOOK_ERRORS = 'AccountFacebookErrors',
  ACCOUNT_FACEBOOK_FORM_SUBMIT = 'AccountFacebookFormSubmit',

  SETTINGS_CONNECT_FB = 'SettingsConnectFB',
  ACCOUNT_STATUS_CLICK = 'AccountStatusClick',

  SIGNUP_VISIT = 'SignupVisit',
  SIGNUP_COUNTRY_CLICK = 'SignupCountryclick',
  SIGNUP_POLITICS_CLICK = 'SignupPoliticsClick',
  SIGNUP_ENTER_CLICK = 'SignupEntrenceClick',
  SIGNIN_ENTER_CLICK = 'SiginpEntrenceClick',
  SIGNUP_CHAT_CLICK = 'SignupChatClick',
  SIGNUP_TRY_TO_FINISH = 'SignupTrytofinish',
  SIGNUP_SUCCESS = 'SignupSuccess',

  SIGNUP_SUBMIT = 'signup-submit',
  SIGNUP_WARNING = 'SignupWarning',
  SIGNUP_PLATFORM = 'SignupPlatformClick',
  SIGNUP_BUDGET = 'SignupBudgetClick',
  SIGNUP_BUDGET_PLATFORM_CLICK = 'SignupStepPlatformBudgetClick',
  SIGNUP_PHONE_CLICK = 'SignupPhonecodeClick',
  SIGNUP_STEP_PHONE_CLICK = 'SignupStepPhoneClick',
  SIGNUP_RECO_CLICK = 'SignupRecoClick',

  PROFILE_SUBMIT = 'profile-submit',

  TELEGRAM_LANDING_BUTTON_TYPE_CLICK = 'TelegramLandingButtonTypeClick',
  TELEGRAM_LANDING_BUTTON_INDUSTRY_CLICK = 'TelegramLandingButtonIndustryClick',
  ACCOUNT_TELEGRAM_CONNECT = 'AccountTelegramConnect',
  ACCOUNT_TELEGRAM_CONNECT_CANCEL = 'AccountTelegramConnectCancel',
  ACCOUNT_TELEGRAM_REQUEST_SUCCESS = 'AccountTelegramRequestSuccess',
  TELEGRAM_ADS_BLOG = 'TelegramadsGoToBlog',

  TIKTOK_CONNECTION_CLICK = 'AccountTiktokConnectClick',
  TIKTOK_CONNECTION_ERROR = 'AccountTiktokConnectError',
  TIKTOK_CONNECTION_SUCCESS = 'AccountTiktokConnectSuccess',
  TIKTOK_STEP_1 = 'AccountTiktokStep1',
  TIKTOK_STEP_2 = 'AccountTiktokStep2',
  TIKTOK_INFO_CREATE_BC = 'AccountTiktokInfoCreateBC',
  TIKTOK_INFO_FIND_BC = 'AccountTiktokInfoFindBC',
  TIKTOK_ADD_BC_LIST = 'AccountTiktokAddBCList',
  TIKTOK_ADD_BC_MANUALLY = 'AccountTiktokAddBCManually',

  BUDGET_MENU_CLICK = 'AllocateBudgetMenuClick',
  BUDGET_FROM_WALLET_CLICK = 'AllocateBudgetFromWalletClick',
  BUDGET_TO_PLATFORM_CLICK = 'AllocateBudgetToPlatformClick',
  BUDGET_TO_ACCOUNT_CLICK = 'AllocateBudgetToAccountClick',
  BUDGET_CLOSE_TAB = 'AllocateBudgetCloseTab',
  BUDGET_REFILL_CLICK = 'AllocateBudgeRefillClick',
  BUDGET_REFILL_SUCCESS = 'AllocateBudgeRefillSuccess',
  BUDGET_REFILL_ERROR = 'AllocateBudgeRefillError',
  BUDGET_REFILL_CONFIRM = 'AllocateBudgeRefillConfirm',
  BUDGET_ENTER_AMOUNT = 'AllocateBudgetEnterAmount',
  BUDGET_AMOUNT_REFILL_AUTO = 'AllocateBudgetAmountRefillAuto',
  ACCOUNT_TIK_TOK_WEBSITE_ERROR = 'AccountTiktokWebsitenameError',
  CLOSE_DOC_MONTH_CLICK = 'CloseDocMonthClick',
  CLOSE_DOC_SHOW_MORE_CLICK = 'CloseDocShowmoreclick',
  CLOSE_DOC_INFO_TAX_SYSTEM_CLICK = 'CloseDocInfoTaxsystemClick',
  CLOSE_DOC_DOWNLOAD = 'CloseDocDownload',
  MAIN_MENU_DOCUMENTS_CLICK = 'MainMenuDocumentsClick',
  TEST_GA_CLIENT_ID = 'TestGaclientid',
  PAYMENT_VISIT = 'PaymentVisit',
  PAYMENT_CURRENCY_CLICK = 'PaymentCurrencyClick',
  PAYMENT_ENTER_AMOUNT = 'PaymentEnterAmount',
  PAYMENT_GO_TO_PAYMENT = 'PaymentGoToPayment',
  PAYMENT_SEND_PROFORMA = 'PaymentSendProforma',
  PAYMENT_DOWNLOAD_PROFORMA = 'PaymentDownloadProforma',
  REFERRER_VISIT_PAGE = 'ReferrerVisitPage',
  REFERRER_CODE_COPY = 'ReferrerCodeCopy',
  PROMOCODE_ACTIVATE_CLICK = 'PromocodeActivateClick',
  PROMOCODE_TRY_TO_ACTIVATE = 'PromocodeTryToActivate',
  PROMOCODE_ACTIVATION_ERROR = 'PromocodeActivationError',
  PROMOCODE_ACTIVATED = 'PromocodeActivated',
  MAIN_MENU_FIN_TERMS_CLICK = 'MainMenuFinTermsClick',
  FIN_TERMS_VISIT_PAGE = 'FinTermsVisitPage',
  FIN_TERMS_VISIT_PAGE_FACEBOOK = 'FinTermsVisitPageFacebook',
  FIN_TERMS_VISIT_PAGE_TIKTOK = 'FinTermsVisitPageTiktok',
  FIN_TERMS_VISIT_PAGE_TELEGRAM_TON = 'FinTermsVisitPageTelegramton',
  FIN_TERMS_VISIT_PAGE_TELEGRAM_EURO = 'FinTermsVisitPageTelegrameuro',
  FIN_TERMS_SEND_TO_CHAT = 'FinTermsSendToChat',
  FIN_TERMS_SEND_TO_CHAT_FACEBOOK = 'FinTermsSendToChatFacebook',
  FIN_TERMS_GO_TO_STRIPE_FACEBOOK = 'FinTermsGoToStripeFacebook',
  FIN_TERMS_GO_TO_STRIPE_TIKTOK = 'FinTermsGoToStripeTiktok',
  FIN_TERMS_GO_TO_STRIPE_TELEGRAM_TON = 'FinTermsGoToStripeTelegramton',
  FIN_TERMS_GO_TO_STRIPE_TELEGRAM_EURO = 'FinTermsGoToStripeTelegrameuro',
  FIN_TERMS_GO_TO_STRIPE = 'FinTermsGoToStripe',
  FIN_TERMS_GO_TO_WALLET = 'FinTermsGoToWallet',
  FIN_TERMS_GO_TO_WALLET_FACEBOOK = 'FinTermsGoToWalletFacebook ',
  FIN_TERMS_GO_TO_WALLET_TIKTOK = 'FinTermsGoToWalletTiktok',
  FIN_TERMS_GO_TO_WALLET_TELEGRAM_TON = 'FinTermsGoToWalletTelegramton',
  FIN_TERMS_GO_TO_WALLET_TELEGRAM_EURO = 'FinTermsGoToWalletTelegrameuro',
  FIN_TERMS_GO_TO_ALLOCATE_BUDGET = 'FinTermsGoToAllocatebudget',
  FIN_TERMS_GO_TO_ALLOCATE_BUDGET_FB = 'FinTermsGoToAllocatebudgetFB',
  FIN_TERMS_GO_TO_ALLOCATE_BUDGET_TT = 'FinTermsGoToAllocatebudgetTT',
  FIN_TERMS_GO_TO_ALLOCATE_BUDGET_TGT = 'FinTermsGoToAllocatebudgetTGT',
  FIN_TERMS_GO_TO_ALLOCATE_BUDGET_TGE = 'FinTermsGoToAllocatebudgetTGE',
  FIN_TERMS_GO_TO_REFERRAL_PROGRAM = 'FinTermsGoToReferralprogram',
  FIN_TERMS_GO_TO_REFERRAL_PROGRAM_FB = 'FinTermsGoToReferralprogramFB',
  FIN_TERMS_GO_TO_REFERRAL_PROGRAM_TT = 'FinTermsGoToReferralprogramTT',
  FIN_TERMS_GO_TO_REFERRAL_PROGRAM_TGT = 'FinTermsGoToReferralprogramTGT',
  FIN_TERMS_GO_TO_REFERRAL_PROGRAM_TGE = 'FinTermsGoToReferralprogramTGE',
  FIN_TERMS_GO_TO_DIFFERENCE = 'FinTermsGoToDifference',
  FIN_TERMS_GO_TO_DIFFERENCE_TGT = 'FinTermsGoToDifferenceTGT',
  FIN_TERMS_GO_TO_DIFFERENCE_TGE = 'FinTermsGoToDifferenceTGE',
  FIN_TERMS_GO_TO_EXCHANGE_RATE = 'FinTermsGoToExchangerate',
  GO_TO_FIN = 'InternalLandingGotofinancialTerms',
  ACCOUNT_FACEBOOK_STANDARD_SELECTED = 'AccountFacebookStandardSelected',
  ACCOUNT_FACEBOOK_STANDARD_POPUP_CLICK = 'AccountFacebookStandardPopupClick',
  ACCOUNT_FACEBOOK_STANDARD_ADD_WEBSITE = 'AccountFacebookStandardAddWebsite',
  ACCOUNT_FACEBOOK_STANDARD_ADD_PAGE = 'AccountFacebookStandardAddPage',
  ACCOUNT_FACEBOOK_STANDARD_TIMEZONE_CHOSE = 'AccountFacebookStandardTimezoneChose',
  ACCOUNT_FACEBOOK_STANDARD_ADD_EMAIL = 'AccountFacebookStandardAddEmail',
  ACCOUNT_FACEBOOK_STANDARD_SUBMIT = 'AccountFacebookStandardSubmit',
  ACCOUNT_FACEBOOK_STANDARD_FINISH = 'AccountFacebookStandardFinish',
  ACCOUNT_FACEBOOK_SHARE_INFO = 'AccountFacebookStandardShareinfo',
  ACCOUNT_CREATION_VIEW = 'AccountCreationView',
  ACCOUNT_CREATION_CANCEL = 'AccountCreationCancel',
  ACCOUNT_CREATION_CREATE = 'AccountCreationCreate',
}

export enum GA4_PLACES {
  SIGNUP = 'Signup',
  SIGNIN = 'Signin',
}

export enum GA4_KEYS {
  PLATFORM = 'platform',
  PLACE = 'place',
  COUNTRY = 'country',
  PROFILE_ID = 'profile_id',
  TYPE = 'type',
  COUNTER = 'counter',
  CNT_FILL_ACCOUNTS = 'cnt_fill_accounts',
  MAX_ACCOUNTS = 'max_accounts',
  WORKFLOW = 'workflow',
  STATUS = 'status',
  PAGE = 'page',
  TEXT = 'text',
  PLATFORM_SINGUP = 'Platform',
  BUDGET = 'Budget',
  INDUSTRY = 'industry',
  WALLET = 'wallet',
  AMOUNT = 'amount',
  COMMISSION = 'commission',
  CURRENCY = 'currency',
  MONTH = 'month',
  GA = 'ga',
  UTM = 'utm',
  EMAIL = 'email',
  CODE = 'code',
  TEXT_ERROR = 'text_error',
  REQUEST = 'request',
}

export type GA4EventParamTypes = {
  [key in GA4_KEYS]?: string | number | null | string[]
}

export interface IGA4EventProps extends GA4EventParamTypes {
  action: GA4_ACTIONS
}

export interface IAuthDashlyParams {
  userId: string | number
}
